import { gql } from '@apollo/client';

export const resellerInfoQuery = gql`
  query resellerInfo {
    currentUser {
      id
      email
      chipReseller {
        id
        name
        verified
        types
        taxExemptType
        contactInfo {
          line1
          line2
          city
          state
          country
          zipcode
          primaryPhone
          website
        }
        shippingAddress {
          line1
          line2
          city
          state
          country
          zip
        }
      }
    }
  }
`;

export const updateChipResellerInfoQuery = gql`
  mutation updateChipResellerInfo($input: UpdateChipResellerInfoInput!) {
    updateChipResellerInfo(input: $input) {
      id
      name
      taxExemptType
      contactInfo {
        primaryPhone
        line1
        line2
        city
        state
        zipcode
        website
      }
      shippingAddress {
        line1
        line2
        city
        state
        zip
      }
    }
  }
`;
